export default {
    sdoh_1150: '10-year lag distributed energy per capita',
    sdoh_2299: '12-month non-partner sexual violence',
    sdoh_147: '90th percentile climatic temperature in the given country-year.',
    sdoh_3: 'Absolute value of average latitude',
    sdoh_1982: 'Adolescent Birth Rates (10 - 19 years of age)',
    sdoh_1196: 'Adult HIV crude death rate',
    sdoh_5: 'Adult HIV death rate',
    sdoh_1240: 'Adult HIV death rate both sexes',
    sdoh_1250: 'Age- and sex-specific SEV for Alcohol use',
    sdoh_2042: 'Age- and sex-specific SEV for Ambient particulate matter',
    sdoh_2144: 'Age- and sex-specific SEV for Bullying',
    sdoh_2104: 'Age- and sex-specific SEV for Chewing tobacco',
    sdoh_1231: 'Age- and sex-specific SEV for Child stunting',
    sdoh_1229: 'Age- and sex-specific SEV for Child underweight',
    sdoh_1233: 'Age- and sex-specific SEV for Child wasting',
    sdoh_2142: 'Age- and sex-specific SEV for Childhood sexual abuse',
    sdoh_2090: 'Age- and sex-specific SEV for Discontinued breastfeeding',
    sdoh_2108: 'Age- and sex-specific SEV for Drug use',
    sdoh_2040: 'Age- and sex-specific SEV for Handwashing',
    sdoh_2154: 'Age- and sex-specific SEV for High blood pressure',
    sdoh_2156: 'Age- and sex-specific SEV for High body-mass index',
    sdoh_2150: 'Age- and sex-specific SEV for High fasting plasma glucose',
    sdoh_2152: 'Age- and sex-specific SEV for High LDL',
    sdoh_2124: 'Age- and sex-specific SEV for High processed meat',
    sdoh_2122: 'Age- and sex-specific SEV for High red meat',
    sdoh_2138: 'Age- and sex-specific SEV for High sodium',
    sdoh_2126: 'Age- and sex-specific SEV for High sweetened beverages',
    sdoh_2326: 'Age- and sex-specific SEV for High temperature',
    sdoh_2136: 'Age- and sex-specific SEV for High trans fat',
    sdoh_2044: 'Age- and sex-specific SEV for Household air pollution',
    sdoh_2160: 'Age- and sex-specific SEV for Impaired kidney function',
    sdoh_2140: 'Age- and sex-specific SEV for Intimate partner violence',
    sdoh_2096: 'Age- and sex-specific SEV for Iron deficiency',
    sdoh_2050: 'Age- and sex-specific SEV for Lead',
    sdoh_2094: 'Age- and sex-specific SEV for Low birth weight',
    sdoh_2158: 'Age- and sex-specific SEV for Low bone mineral density',
    sdoh_2130: 'Age- and sex-specific SEV for Low calcium',
    sdoh_2128: 'Age- and sex-specific SEV for Low fiber',
    sdoh_2110: 'Age- and sex-specific SEV for Low fruit',
    sdoh_2114: 'Age- and sex-specific SEV for Low legumes',
    sdoh_2120: 'Age- and sex-specific SEV for Low milk',
    sdoh_2118: 'Age- and sex-specific SEV for Low nuts and seeds',
    sdoh_2132: 'Age- and sex-specific SEV for Low omega-3',
    sdoh_2148: 'Age- and sex-specific SEV for Low physical activity',
    sdoh_2134: 'Age- and sex-specific SEV for Low PUFA',
    sdoh_2327: 'Age- and sex-specific SEV for Low temperature',
    sdoh_2112: 'Age- and sex-specific SEV for Low vegetables',
    sdoh_2116: 'Age- and sex-specific SEV for Low whole grains',
    sdoh_2088: 'Age- and sex-specific SEV for Non-exclusive breastfeeding',
    sdoh_2054: 'Age- and sex-specific SEV for Occupational arsenic',
    sdoh_2052: 'Age- and sex-specific SEV for Occupational asbestos',
    sdoh_2078: 'Age- and sex-specific SEV for Occupational asthmagens',
    sdoh_2056: 'Age- and sex-specific SEV for Occupational benzene',
    sdoh_2058: 'Age- and sex-specific SEV for Occupational beryllium',
    sdoh_2060: 'Age- and sex-specific SEV for Occupational cadmium',
    sdoh_2062: 'Age- and sex-specific SEV for Occupational chromium',
    sdoh_2064: 'Age- and sex-specific SEV for Occupational diesel',
    sdoh_2086: 'Age- and sex-specific SEV for Occupational ergonomic',
    sdoh_2066: 'Age- and sex-specific SEV for Occupational formaldehyde',
    sdoh_2068: 'Age- and sex-specific SEV for Occupational nickel',
    sdoh_2082: 'Age- and sex-specific SEV for Occupational noise',
    sdoh_2070: 'Age- and sex-specific SEV for Occupational PAH',
    sdoh_2080: 'Age- and sex-specific SEV for Occupational particulates',
    sdoh_2072: 'Age- and sex-specific SEV for Occupational silica',
    sdoh_2074: 'Age- and sex-specific SEV for Occupational sulfuric acid',
    sdoh_2076: 'Age- and sex-specific SEV for Occupational trichloroethylene',
    sdoh_2046: 'Age- and sex-specific SEV for Ozone',
    sdoh_2048: 'Age- and sex-specific SEV for Radon',
    sdoh_2106: 'Age- and sex-specific SEV for Secondhand smoke',
    sdoh_2092: 'Age- and sex-specific SEV for Short gestation',
    sdoh_2102: 'Age- and sex-specific SEV for Smoking',
    sdoh_866: 'Age- and sex-specific SEV for Unsafe sanitation',
    sdoh_863: 'Age- and sex-specific SEV for Unsafe water',
    sdoh_2098: 'Age- and sex-specific SEV for Vitamin A deficiency',
    sdoh_2100: 'Age- and sex-specific SEV for Zinc deficiency',
    sdoh_13: 'Age-Specific Fertility Rate',
    sdoh_205: 'Age-Standardize Prevalence of Severe Anemia',
    sdoh_1168: 'Age-standardized bone mineral density among population age 60+ years',
    sdoh_2343: 'Age-standardized daily smoking prevalence, both sexes',
    sdoh_1249: 'Age-standardized death rate of diabetes (0-15 years) (per 100,000)',
    sdoh_1107: 'Age-standardized melanoma',
    sdoh_1145: 'Age-standardized prevalence of cannabis dependence in women of reproductive age',
    sdoh_1142: 'Age-standardized prevalence of cocaine dependence in women of reproductive-age',
    sdoh_1144: 'Age-standardized prevalence of opioid dependence in women of reproductive age',
    sdoh_1100: 'Age-standardized proportion adult underweight',
    sdoh_1251: 'Age-standardized SEV for Alcohol use',
    sdoh_2043: 'Age-standardized SEV for Ambient particulate matter',
    sdoh_2145: 'Age-standardized SEV for Bullying',
    sdoh_2105: 'Age-standardized SEV for Chewing tobacco',
    sdoh_1232: 'Age-standardized SEV for Child stunting',
    sdoh_1230: 'Age-standardized SEV for Child underweight',
    sdoh_1234: 'Age-standardized SEV for Child wasting',
    sdoh_2143: 'Age-standardized SEV for Childhood sexual abuse',
    sdoh_2091: 'Age-standardized SEV for Discontinued breastfeeding',
    sdoh_2109: 'Age-standardized SEV for Drug use',
    sdoh_2041: 'Age-standardized SEV for Handwashing',
    sdoh_2155: 'Age-standardized SEV for High blood pressure',
    sdoh_2157: 'Age-standardized SEV for High body-mass index',
    sdoh_2151: 'Age-standardized SEV for High fasting plasma glucose',
    sdoh_2153: 'Age-standardized SEV for High LDL',
    sdoh_2125: 'Age-standardized SEV for High processed meat',
    sdoh_2123: 'Age-standardized SEV for High red meat',
    sdoh_2139: 'Age-standardized SEV for High sodium',
    sdoh_2127: 'Age-standardized SEV for High sweetened beverages',
    sdoh_2328: 'Age-standardized SEV for High temperature',
    sdoh_2137: 'Age-standardized SEV for High trans fat',
    sdoh_2045: 'Age-standardized SEV for Household air pollution',
    sdoh_2161: 'Age-standardized SEV for Impaired kidney function',
    sdoh_2141: 'Age-standardized SEV for Intimate partner violence',
    sdoh_2097: 'Age-standardized SEV for Iron deficiency',
    sdoh_2051: 'Age-standardized SEV for Lead',
    sdoh_2095: 'Age-standardized SEV for Low birth weight',
    sdoh_2159: 'Age-standardized SEV for Low bone mineral density',
    sdoh_2131: 'Age-standardized SEV for Low calcium',
    sdoh_2129: 'Age-standardized SEV for Low fiber',
    sdoh_2111: 'Age-standardized SEV for Low fruit',
    sdoh_2115: 'Age-standardized SEV for Low legumes',
    sdoh_2121: 'Age-standardized SEV for Low milk',
    sdoh_2119: 'Age-standardized SEV for Low nuts and seeds',
    sdoh_2133: 'Age-standardized SEV for Low omega-3',
    sdoh_2149: 'Age-standardized SEV for Low physical activity',
    sdoh_2135: 'Age-standardized SEV for Low PUFA',
    sdoh_2329: 'Age-standardized SEV for Low temperature',
    sdoh_2113: 'Age-standardized SEV for Low vegetables',
    sdoh_2117: 'Age-standardized SEV for Low whole grains',
    sdoh_2089: 'Age-standardized SEV for Non-exclusive breastfeeding',
    sdoh_2055: 'Age-standardized SEV for Occupational arsenic',
    sdoh_2053: 'Age-standardized SEV for Occupational asbestos',
    sdoh_2079: 'Age-standardized SEV for Occupational asthmagens',
    sdoh_2057: 'Age-standardized SEV for Occupational benzene',
    sdoh_2059: 'Age-standardized SEV for Occupational beryllium',
    sdoh_2061: 'Age-standardized SEV for Occupational cadmium',
    sdoh_2063: 'Age-standardized SEV for Occupational chromium',
    sdoh_2065: 'Age-standardized SEV for Occupational diesel',
    sdoh_2087: 'Age-standardized SEV for Occupational ergonomic',
    sdoh_2067: 'Age-standardized SEV for Occupational formaldehyde',
    sdoh_2069: 'Age-standardized SEV for Occupational nickel',
    sdoh_2083: 'Age-standardized SEV for Occupational noise',
    sdoh_2071: 'Age-standardized SEV for Occupational PAH',
    sdoh_2081: 'Age-standardized SEV for Occupational particulates',
    sdoh_2073: 'Age-standardized SEV for Occupational silica',
    sdoh_2075: 'Age-standardized SEV for Occupational sulfuric acid',
    sdoh_2077: 'Age-standardized SEV for Occupational trichloroethylene',
    sdoh_2047: 'Age-standardized SEV for Ozone',
    sdoh_2049: 'Age-standardized SEV for Radon',
    sdoh_2107: 'Age-standardized SEV for Secondhand smoke',
    sdoh_2093: 'Age-standardized SEV for Short gestation',
    sdoh_2103: 'Age-standardized SEV for Smoking',
    sdoh_2039: 'Age-standardized SEV for Unsafe sanitation',
    sdoh_2038: 'Age-standardized SEV for Unsafe water',
    sdoh_2099: 'Age-standardized SEV for Vitamin A deficiency',
    sdoh_2101: 'Age-standardized SEV for Zinc deficiency',
    sdoh_2011: 'Alcohol (liters per capita) [US R/E]',
    sdoh_2387: 'Alcohol availability per capita, smoothed',
    sdoh_273: 'Alcohol binge drinker proportion, age-standardized',
    sdoh_1211: 'Alcohol consumption, age standardized, in grams per day',
    sdoh_1212: 'Alcohol drinker proportion, age-standardized',
    sdoh_1191: 'All age underweight',
    sdoh_7: 'Antenatal Care (1 visit) Coverage (proportion)',
    sdoh_8: 'Antenatal Care (4 visits) Coverage (proportion)',
    sdoh_1105: 'Antibiotics for diarrhea',
    sdoh_1103: 'Antibiotics for LRI',
    sdoh_1132: 'Antimalarial effective treatment_MAP',
    sdoh_1185: 'Asbestos consumption (metric tons per year per capita)',
    sdoh_2355: 'Ascariasis Prevalence',
    sdoh_56: 'Average latitude',
    sdoh_2289: 'BAC law  professional drivers (quartile)',
    sdoh_2287: 'BAC law general population (quartile)',
    sdoh_2288: 'BAC law youth drivers (quartile)',
    sdoh_1980: 'Bacille Calmette-Guerin (BCG) vaccine coverage (proportion)',
    sdoh_2307: 'BCG lagged five year coverage (proportion)',
    sdoh_197: 'Birth prevalence of CHD',
    sdoh_198: 'Birth prevalence of congenital chromosomal anomalies',
    sdoh_890: 'calcium unadjusted(g)',
    sdoh_467: 'chagasPrevPAHO',
    sdoh_69: 'Cholesterol (total, mean per capita)',
    sdoh_2336: 'Chronic Hepatitis C age standardized',
    sdoh_16: 'Coastal Population within 10km (proportion)',
    sdoh_1207: 'Composite fortification standard and folic acid inclusion',
    sdoh_1242: 'Composite fortification standard and iron inclusion',
    sdoh_18: 'Contraception (Modern) Prevalence (proportion by age)',
    sdoh_19: 'Contraception (Modern) Prevalence (proportion)',
    sdoh_24: 'Cumulative Cigarettes (10 Years)',
    sdoh_25: 'Cumulative Cigarettes (15 Years)',
    sdoh_26: 'Cumulative Cigarettes (20 Years)',
    sdoh_27: 'Cumulative Cigarettes (5 Years)',
    sdoh_2356: 'Custom Age-standardized and sex-specific SEV for Alcohol use',
    sdoh_1197: 'Demand for contraception satisfied with modern methods',
    sdoh_1198: 'Demand for contraception satisfied with modern methods, by age',
    sdoh_2324: 'Dengue all-age CSMR',
    sdoh_248: 'Dengue outbreaks (binary)',
    sdoh_872:
        'Dengue Reporting Trends (transformed into relative risks, relative to that countryÃ¢â‚¬â„¢s mean incidence)',
    sdoh_1999: 'Dentists per capita',
    sdoh_30: 'Diabetes Age-Specific Prevalence (proportion)',
    sdoh_29: 'Diabetes Age-Standardized Prevalence (proportion)',
    sdoh_28: 'Diabetes Fasting Plasma Glucose (mmol/L), age-standardized 25+',
    sdoh_2279: 'Diabetes Fasting Plasma Glucose (mmol/L), by age',
    sdoh_1163: 'Diet high in sodium',
    sdoh_1162: 'Diet high in trans fatty acids',
    sdoh_1065: 'Dietary zinc unadjusted (mg)',
    sdoh_32: 'DTP3 Coverage (proportion)',
    sdoh_2308: 'DTP3 lagged five year coverage (proportion)',
    sdoh_875: 'echinococcosis endemicity ',
    sdoh_33: 'Education (years per capita)',
    sdoh_2006: 'Education (years per capita) [US R/E]',
    sdoh_1975: 'Education (years per capita) aggregated by age (15+) and sex',
    sdoh_2325: 'Education (years per capita) aggregated by age(15+) and sex [US R/E]',
    sdoh_2019: 'Education Absolute Inequality (AAID)',
    sdoh_2024: 'Education Absolute Inequality (AAID), age-standardized',
    sdoh_2029: 'Education Absolute Inequality (AAID), maternal',
    sdoh_845: 'Education age-standardized',
    sdoh_2020: 'Education Relative Inequality (Gini)',
    sdoh_2025: 'Education Relative Inequality (Gini), age-standardized',
    sdoh_2030: 'Education Relative Inequality (Gini), maternal',
    sdoh_108: 'Elevation 100 to 500m (proportion)',
    sdoh_114: 'Elevation 500 to 1500m (proportion)',
    sdoh_109: 'Elevation Over 1500m (proportion)',
    sdoh_121: 'Elevation Under 100m (proportion)',
    sdoh_977: 'energy unadjusted(kcal)',
    sdoh_479: 'Enhanced Vegetation Index long term average 2000-2012 (mean)',
    sdoh_2008: 'Fasting plasma glucose [US R/E]',
    sdoh_39: 'Female HIV death rate per 1 for ages 15-49',
    sdoh_902: 'fiber unadjusted(g)',
    sdoh_1153: 'Folic acid unadjusted (ug)',
    sdoh_1194: 'Fortification standard',
    sdoh_1195: 'Fortification standard including folic acid',
    sdoh_1241: 'Fortification standard including iron',
    sdoh_1093: 'Fraction of OOP Health Expenditure',
    sdoh_914: 'fruits unadjusted(g)',
    sdoh_2014: 'Fruits, unadjusted (g) [US R/E]',
    sdoh_2270: 'Gallup: Negative Experience Index',
    sdoh_851: 'GDP per capita base 2010 ',
    sdoh_42: 'Gold production (binary)',
    sdoh_2277: 'Gold production (kg) per capita, smoothed with 20-year lag',
    sdoh_2333: 'Government Spending on Health',
    sdoh_1089: 'Health expenditure (per capita)',
    sdoh_1974: 'Health Industry Workers',
    sdoh_1111: 'Health worker density',
    sdoh_1099: 'Healthcare access and quality index',
    sdoh_2271: 'Hemoglobin C (sickle type C) trait',
    sdoh_2272: 'Hemoglobin S (sickle type S) trait',
    sdoh_200: 'Hemoglobinopathies Prevalence x Excess Mortality',
    sdoh_262: 'Hemoglobinopathies Prevalence x Excess Mortality (excluding G6PD deficiency)',
    sdoh_2282: 'Hepatitis A Seroprevalence (anti-HAV) age standardized',
    sdoh_1201: 'Hepatitis B 3-dose coverage (proportion)',
    sdoh_1247: 'Hepatitis B 3-dose coverage (proportion), lagged 10 years',
    sdoh_1246: 'Hepatitis B 3-dose coverage (proportion), lagged 5 years',
    sdoh_2283: 'Hepatitis B Seroprevalence (HBsAg) age standardized',
    sdoh_1981: 'Hepatitis B vaccine coverage (proportion), aged through time',
    sdoh_2284: 'Hepatitis C Seroprevalence (anti-HCV) age standardized',
    sdoh_2285: 'Hepatitis E Seroprevalence (anti-HEV) age standardized',
    sdoh_2316: 'HepB3 lagged five year coverage (proportion)',
    sdoh_2313: 'Hib3 lagged five year coverage (proportion)',
    sdoh_2342:
        'Hib3 transformed: population-level coverage, including indirect effects (proportion)',
    sdoh_47: 'Hib3 Vaccine Coverage (proportion)',
    sdoh_2338: 'High risk MenAfriVac coverage (proportion)',
    sdoh_1016: 'HIV age-standardized prevalence',
    sdoh_1996: 'HIV mortality rate',
    sdoh_986: 'HIV mortality, females, 10-54',
    sdoh_49: 'HIV Prevalence Unadjusted (proportion)',
    sdoh_50: 'Hospital Beds (per 1000)',
    sdoh_2286: 'HPV1 coverage (proportion)',
    sdoh_2330: 'HPV2 coverage (proportion)',
    sdoh_160: 'Improved Water Source (proportion with access)',
    sdoh_51: 'In-Facility Delivery (proportion)',
    sdoh_2400: 'Income per capita',
    sdoh_267:
        'Indicator for Central Europe, Eastern Europe, and Central Asia superregion (location_id=31)',
    sdoh_260: 'Indicator for High-income superregion (location_id=64)',
    sdoh_268: 'Indicator for Latin America and Caribbean superregion (location_id=103)',
    sdoh_269: 'Indicator for North Africa and Middle East superregion (location_id=137)',
    sdoh_270: 'Indicator for South Asia superregion (location_id=158)',
    sdoh_266: 'Indicator for Southeast Asia, East Asia, and Oceania superregion (location_id=4)',
    sdoh_271: 'Indicator for Sub-Saharan Africa superregion (location_id=166)',
    sdoh_105: 'Indoor Air Pollution (All Cooking Fuels)',
    sdoh_2319: 'INJ time',
    sdoh_2331: 'Inpatient utilization envelope',
    sdoh_1209: 'Intravenous drug use (age-standardized proportion)',
    sdoh_1208: 'Intravenous drug use (proportion by age)',
    sdoh_1113: 'Iron energy unadjusted (mg)',
    sdoh_884: 'Japanese encelphalitis endemic area (binary)',
    sdoh_2511: 'K-12 spending per student',
    sdoh_55: 'Landlocked Nation (binary)',
    sdoh_111: 'Latitude 15 to 30 (proportion)',
    sdoh_112: 'Latitude 30 to 45 (proportion)',
    sdoh_113: 'Latitude Over 45 (proportion)',
    sdoh_107: 'Latitude Under 15 (proportion)',
    sdoh_57: 'LDI (I$ per capita)',
    sdoh_2007: 'LDI (I$ per capita) [US R/E]',
    sdoh_1157: 'Lead exposure',
    sdoh_58: 'Lead Gas Outphase (binary)',
    sdoh_2: 'Legality of Abortion',
    sdoh_2297: 'Liters of alcohol consumed per capita',
    sdoh_2334: 'Liters of alcohol consumed per capita by age and sex',
    sdoh_2298: "Live births (by child's sex and maternal age)",
    sdoh_1106: 'Live births (by sex)',
    sdoh_60: 'Live Births (thousands)',
    sdoh_84: 'Live Births 35+ (proportion)',
    sdoh_85: 'Live Births 40+ (proportion)',
    sdoh_2406: 'Log of population density',
    sdoh_1984: 'Log total health expenditure per capita',
    sdoh_1182: 'Log-transformed age-standardized SEV scalar for both sexes combined: TB',
    sdoh_783: 'Log-transformed age-standardized SEV scalar: A Fib',
    sdoh_1936: 'Log-transformed age-standardized SEV scalar: ALL',
    sdoh_1947: "Log-transformed age-standardized SEV scalar: Alzheimer's",
    sdoh_1938: 'Log-transformed age-standardized SEV scalar: AML',
    sdoh_828: 'Log-transformed age-standardized SEV scalar: Animal',
    sdoh_2244: 'Log-transformed age-standardized SEV scalar: Anxiety',
    sdoh_784: 'Log-transformed age-standardized SEV scalar: Aort An',
    sdoh_794: 'Log-transformed age-standardized SEV scalar: Asthma',
    sdoh_808: 'Log-transformed age-standardized SEV scalar: Back Pain',
    sdoh_773: 'Log-transformed age-standardized SEV scalar: Bladder C',
    sdoh_2207: 'Log-transformed age-standardized SEV scalar: Blindness',
    sdoh_762: 'Log-transformed age-standardized SEV scalar: Breast C',
    sdoh_2348: 'Log-Transformed age-standardized SEV scalar: Burkitt',
    sdoh_811: 'Log-transformed age-standardized SEV scalar: Cataract',
    sdoh_2196: 'Log-transformed age-standardized SEV scalar: CAVD',
    sdoh_797: 'Log-transformed age-standardized SEV scalar: Cirr HepB',
    sdoh_798: 'Log-transformed age-standardized SEV scalar: Cirr HepC',
    sdoh_1028: 'Log-transformed age-standardized SEV scalar: Cirrhosis',
    sdoh_1937: 'Log-transformed age-standardized SEV scalar: CLL',
    sdoh_1939: 'Log-transformed age-standardized SEV scalar: CML',
    sdoh_782: 'Log-transformed age-standardized SEV scalar: CMP',
    sdoh_765: 'Log-transformed age-standardized SEV scalar: Colorect C',
    sdoh_788: 'Log-transformed age-standardized SEV scalar: COPD',
    sdoh_815: 'Log-transformed age-standardized SEV scalar: Cyclist',
    sdoh_802: 'Log-transformed age-standardized SEV scalar: Depression',
    sdoh_740: 'Log-transformed age-standardized SEV scalar: Diarrhea',
    sdoh_2247: 'Log-transformed age-standardized SEV scalar: Disaster',
    sdoh_821: 'Log-transformed age-standardized SEV scalar: Drown',
    sdoh_1904: 'Log-transformed age-standardized SEV scalar: Drug-Sus HIV-TB',
    sdoh_1900: 'Log-transformed age-standardized SEV scalar: Drug-Sus TB',
    sdoh_2181: 'Log-transformed age-standardized SEV scalar: Ectopic Preg',
    sdoh_1912: 'Log-transformed age-standardized SEV scalar: Encepha',
    sdoh_786: 'Log-transformed age-standardized SEV scalar: Endocar',
    sdoh_754: 'Log-transformed age-standardized SEV scalar: Esophag C',
    sdoh_831: 'Log-transformed age-standardized SEV scalar: F Body',
    sdoh_832: 'Log-transformed age-standardized SEV scalar: F Body Asp',
    sdoh_820: 'Log-transformed age-standardized SEV scalar: Falls',
    sdoh_822: 'Log-transformed age-standardized SEV scalar: Fire',
    sdoh_1946: 'Log-transformed age-standardized SEV scalar: Gall Bile',
    sdoh_769: 'Log-transformed age-standardized SEV scalar: Gallblad C',
    sdoh_1964: 'Log-transformed age-standardized SEV scalar: Glaucoma',
    sdoh_809: 'Log-transformed age-standardized SEV scalar: Gout',
    sdoh_1899: 'Log-transformed age-standardized SEV scalar: Group I',
    sdoh_812: 'Log-transformed age-standardized SEV scalar: Hearing',
    sdoh_2215: 'Log-transformed age-standardized SEV scalar: Heat + cold',
    sdoh_751: 'Log-transformed age-standardized SEV scalar: Hep',
    sdoh_752: 'Log-transformed age-standardized SEV scalar: Hep B',
    sdoh_753: 'Log-transformed age-standardized SEV scalar: Hep C',
    sdoh_1903: 'Log-transformed age-standardized SEV scalar: HIV',
    sdoh_805: 'Log-transformed age-standardized SEV scalar: ID',
    sdoh_801: 'Log-transformed age-standardized SEV scalar: Idiopathic epilepsy',
    sdoh_778: 'Log-transformed age-standardized SEV scalar: IHD',
    sdoh_2211: 'Log-transformed age-standardized SEV scalar: Inj Pois CO',
    sdoh_2213: 'Log-transformed age-standardized SEV scalar: Inj Pois Oth',
    sdoh_1967: 'Log-transformed age-standardized SEV scalar: Injuries',
    sdoh_781: 'Log-transformed age-standardized SEV scalar: Intrahem Stroke',
    sdoh_780: 'Log-transformed age-standardized SEV scalar: Isch Stroke',
    sdoh_772: 'Log-transformed age-standardized SEV scalar: Kidney C',
    sdoh_760: 'Log-transformed age-standardized SEV scalar: Larynx C',
    sdoh_776: 'Log-transformed age-standardized SEV scalar: Leukemia',
    sdoh_766: 'Log-transformed age-standardized SEV scalar: Lip Oral C',
    sdoh_756: 'Log-transformed age-standardized SEV scalar: Liver C',
    sdoh_757: 'Log-transformed age-standardized SEV scalar: Liver C HepB',
    sdoh_758: 'Log-transformed age-standardized SEV scalar: Liver C HepC',
    sdoh_2190: 'Log-transformed age-standardized SEV scalar: Liver C MASH',
    sdoh_744: 'Log-transformed age-standardized SEV scalar: LRI',
    sdoh_761: 'Log-transformed age-standardized SEV scalar: Lung C',
    sdoh_1934: 'Log-transformed age-standardized SEV scalar: Lymphoma',
    sdoh_1965: 'Log-transformed age-standardized SEV scalar: Macular',
    sdoh_2249: 'Log-transformed age-standardized SEV scalar: Mat Abort',
    sdoh_748: 'Log-transformed age-standardized SEV scalar: Mat Hem',
    sdoh_2248: 'Log-transformed age-standardized SEV scalar: Mat HIV',
    sdoh_2235: 'Log-transformed age-standardized SEV scalar: Mat HTN',
    sdoh_2239: 'Log-transformed age-standardized SEV scalar: Mat Indir',
    sdoh_2240: 'Log-transformed age-standardized SEV scalar: Mat Late',
    sdoh_749: 'Log-transformed age-standardized SEV scalar: Mat Sepsis',
    sdoh_1019: 'Log-transformed age-standardized SEV scalar: Maternal',
    sdoh_803: 'Log-transformed age-standardized SEV scalar: MDD',
    sdoh_1905: 'Log-transformed age-standardized SEV scalar: MDR-HIV-TB',
    sdoh_1901: 'Log-transformed age-standardized SEV scalar: MDR-TB',
    sdoh_747: 'Log-transformed age-standardized SEV scalar: Measles',
    sdoh_824: 'Log-transformed age-standardized SEV scalar: Mech',
    sdoh_825: 'Log-transformed age-standardized SEV scalar: Mech Gun',
    sdoh_1907: 'Log-transformed age-standardized SEV scalar: Meningitis',
    sdoh_775: 'Log-transformed age-standardized SEV scalar: Mesothel',
    sdoh_816: 'Log-transformed age-standardized SEV scalar: Mot Cyc',
    sdoh_817: 'Log-transformed age-standardized SEV scalar: Mot Veh',
    sdoh_1949: 'Log-transformed age-standardized SEV scalar: MS',
    sdoh_1935: 'Log-transformed age-standardized SEV scalar: Myeloma',
    sdoh_767: 'Log-transformed age-standardized SEV scalar: Nasoph C',
    sdoh_2242: 'Log-transformed age-standardized SEV scalar: NCD',
    sdoh_2187: 'Log-transformed age-standardized SEV scalar: Neonatal',
    sdoh_1917: 'Log-transformed age-standardized SEV scalar: NN Enceph',
    sdoh_1919: 'Log-transformed age-standardized SEV scalar: NN Hemol',
    sdoh_1918: 'Log-transformed age-standardized SEV scalar: NN Sepsis',
    sdoh_830: 'Log-transformed age-standardized SEV scalar: Non Ven',
    sdoh_2179: 'Log-transformed age-standardized SEV scalar: Obst Labor',
    sdoh_806: 'Log-transformed age-standardized SEV scalar: Osteoarth',
    sdoh_2352: 'Log-Transformed age-standardized SEV scalar: Osteoarth Hip',
    sdoh_2354: 'Log-Transformed age-standardized SEV scalar: Osteoarth Knee',
    sdoh_787: 'Log-transformed age-standardized SEV scalar: Oth Cardio',
    sdoh_2346: 'Log-Transformed age-standardized SEV scalar: Oth Cirr',
    sdoh_1943: 'Log-transformed age-standardized SEV scalar: Oth CMP',
    sdoh_834: 'Log-transformed age-standardized SEV scalar: Oth F Body',
    sdoh_739: 'Log-transformed age-standardized SEV scalar: Oth HIV',
    sdoh_1940: 'Log-transformed age-standardized SEV scalar: Oth Leukemia',
    sdoh_759: 'Log-transformed age-standardized SEV scalar: Oth Liver C',
    sdoh_2350: 'Log-Transformed age-standardized SEV scalar: Oth Lymphoma',
    sdoh_2241: 'Log-transformed age-standardized SEV scalar: Oth Mat',
    sdoh_827: 'Log-transformed age-standardized SEV scalar: Oth Mech',
    sdoh_1920: 'Log-transformed age-standardized SEV scalar: Oth NN',
    sdoh_768: 'Log-transformed age-standardized SEV scalar: Oth Phar C',
    sdoh_818: 'Log-transformed age-standardized SEV scalar: Oth Road',
    sdoh_819: 'Log-transformed age-standardized SEV scalar: Oth Trans',
    sdoh_835: 'Log-transformed age-standardized SEV scalar: Oth Unint',
    sdoh_840: 'Log-transformed age-standardized SEV scalar: Oth Viol',
    sdoh_746: 'Log-transformed age-standardized SEV scalar: Otitis',
    sdoh_771: 'Log-transformed age-standardized SEV scalar: Ovary C',
    sdoh_785: 'Log-transformed age-standardized SEV scalar: PAD',
    sdoh_770: 'Log-transformed age-standardized SEV scalar: Pancreas C',
    sdoh_800: 'Log-transformed age-standardized SEV scalar: Pancreatit',
    sdoh_814: 'Log-transformed age-standardized SEV scalar: Pedest',
    sdoh_823: 'Log-transformed age-standardized SEV scalar: Poison',
    sdoh_764: 'Log-transformed age-standardized SEV scalar: Prostate C',
    sdoh_1945: 'Log-transformed age-standardized SEV scalar: PUD',
    sdoh_777: 'Log-transformed age-standardized SEV scalar: RHD',
    sdoh_1963: 'Log-transformed age-standardized SEV scalar: Rheu Arth',
    sdoh_813: 'Log-transformed age-standardized SEV scalar: Road Inj',
    sdoh_1968: 'Log-transformed age-standardized SEV scalar: Self Fire',
    sdoh_836: 'Log-transformed age-standardized SEV scalar: Self Harm',
    sdoh_1969: 'Log-transformed age-standardized SEV scalar: Self Other',
    sdoh_1970: 'Log-transformed age-standardized SEV scalar: Sex Viol',
    sdoh_1966: 'Log-transformed age-standardized SEV scalar: SIDS',
    sdoh_755: 'Log-transformed age-standardized SEV scalar: Stomach C',
    sdoh_779: 'Log-transformed age-standardized SEV scalar: Stroke',
    sdoh_2192: 'Log-transformed age-standardized SEV scalar: Sub Hem',
    sdoh_737: 'Log-transformed age-standardized SEV scalar: TB',
    sdoh_774: 'Log-transformed age-standardized SEV scalar: Thyroid C',
    sdoh_2198: 'Log-transformed age-standardized SEV scalar: Upper Digest',
    sdoh_745: 'Log-transformed age-standardized SEV scalar: URI',
    sdoh_763: 'Log-transformed age-standardized SEV scalar: Uterus C',
    sdoh_2194: 'Log-transformed age-standardized SEV scalar: Valvular',
    sdoh_829: 'Log-transformed age-standardized SEV scalar: Venom',
    sdoh_838: 'Log-transformed age-standardized SEV scalar: Viol Gun',
    sdoh_839: 'Log-transformed age-standardized SEV scalar: Viol Knife',
    sdoh_837: 'Log-transformed age-standardized SEV scalar: Violence',
    sdoh_1906: 'Log-transformed age-standardized SEV scalar: XDR-HIV-TB',
    sdoh_1902: 'Log-transformed age-standardized SEV scalar: XDR-TB',
    sdoh_2002: 'Log-transformed coal production (per capita)',
    sdoh_585: 'Log-transformed SEV scalar: A Fib',
    sdoh_1865: 'Log-transformed SEV scalar: ALL',
    sdoh_1876: "Log-transformed SEV scalar: Alzheimer's",
    sdoh_1867: 'Log-transformed SEV scalar: AML',
    sdoh_718: 'Log-transformed SEV scalar: Animal',
    sdoh_625: 'Log-transformed SEV scalar: Anxiety',
    sdoh_586: 'Log-transformed SEV scalar: Aort An',
    sdoh_596: 'Log-transformed SEV scalar: Asthma',
    sdoh_660: 'Log-transformed SEV scalar: Back Pain',
    sdoh_570: 'Log-transformed SEV scalar: Bladder C',
    sdoh_2208: 'Log-transformed SEV scalar: Blindness',
    sdoh_556: 'Log-transformed SEV scalar: Breast C',
    sdoh_2347: 'Log-Transformed SEV scalar: Burkitt',
    sdoh_689: 'Log-transformed SEV scalar: Cataract',
    sdoh_2197: 'Log-transformed SEV scalar: CAVD',
    sdoh_599: 'Log-transformed SEV scalar: Cirr HepB',
    sdoh_600: 'Log-transformed SEV scalar: Cirr HepC',
    sdoh_1049: 'Log-transformed SEV scalar: Cirrhosis',
    sdoh_1866: 'Log-transformed SEV scalar: CLL',
    sdoh_1868: 'Log-transformed SEV scalar: CML',
    sdoh_584: 'Log-transformed SEV scalar: CMP',
    sdoh_559: 'Log-transformed SEV scalar: Colorect C',
    sdoh_590: 'Log-transformed SEV scalar: COPD',
    sdoh_704: 'Log-transformed SEV scalar: Cyclist',
    sdoh_621: 'Log-transformed SEV scalar: Depression',
    sdoh_486: 'Log-transformed SEV scalar: Diarrhea',
    sdoh_731: 'Log-transformed SEV scalar: Disaster',
    sdoh_710: 'Log-transformed SEV scalar: Drown',
    sdoh_1836: 'Log-transformed SEV scalar: Drug-Sus HIV-TB',
    sdoh_1832: 'Log-transformed SEV scalar: Drug-Sus TB',
    sdoh_2182: 'Log-transformed SEV scalar: Ectopic Preg',
    sdoh_1843: 'Log-transformed SEV scalar: Encepha',
    sdoh_588: 'Log-transformed SEV scalar: Endocar',
    sdoh_548: 'Log-transformed SEV scalar: Esophag C',
    sdoh_721: 'Log-transformed SEV scalar: F Body',
    sdoh_722: 'Log-transformed SEV scalar: F Body Asp',
    sdoh_709: 'Log-transformed SEV scalar: Falls',
    sdoh_711: 'Log-transformed SEV scalar: Fire',
    sdoh_1875: 'Log-transformed SEV scalar: Gall Bile',
    sdoh_563: 'Log-transformed SEV scalar: Gallblad C',
    sdoh_1893: 'Log-transformed SEV scalar: Glaucoma',
    sdoh_662: 'Log-transformed SEV scalar: Gout',
    sdoh_1831: 'Log-transformed SEV scalar: Group I',
    sdoh_692: 'Log-transformed SEV scalar: Hearing',
    sdoh_2216: 'Log-transformed SEV scalar: Heat + cold',
    sdoh_541: 'Log-transformed SEV scalar: Hep',
    sdoh_543: 'Log-transformed SEV scalar: Hep B',
    sdoh_544: 'Log-transformed SEV scalar: Hep C',
    sdoh_1835: 'Log-transformed SEV scalar: HIV',
    sdoh_634: 'Log-transformed SEV scalar: ID',
    sdoh_614: 'Log-transformed SEV scalar: Idiopathic epilepsy',
    sdoh_580: 'Log-transformed SEV scalar: IHD',
    sdoh_2212: 'Log-transformed SEV scalar: Inj Pois CO',
    sdoh_2214: 'Log-transformed SEV scalar: Inj Pois Oth',
    sdoh_1895: 'Log-transformed SEV scalar: Injuries',
    sdoh_583: 'Log-transformed SEV scalar: Intrahem Stroke',
    sdoh_582: 'Log-transformed SEV scalar: Isch Stroke',
    sdoh_569: 'Log-transformed SEV scalar: Kidney C',
    sdoh_554: 'Log-transformed SEV scalar: Larynx C',
    sdoh_577: 'Log-transformed SEV scalar: Leukemia',
    sdoh_560: 'Log-transformed SEV scalar: Lip Oral C',
    sdoh_550: 'Log-transformed SEV scalar: Liver C',
    sdoh_551: 'Log-transformed SEV scalar: Liver C HepB',
    sdoh_552: 'Log-transformed SEV scalar: Liver C HepC',
    sdoh_2191: 'Log-transformed SEV scalar: Liver C MASH',
    sdoh_491: 'Log-transformed SEV scalar: LRI',
    sdoh_555: 'Log-transformed SEV scalar: Lung C',
    sdoh_1863: 'Log-transformed SEV scalar: Lymphoma',
    sdoh_1894: 'Log-transformed SEV scalar: Macular',
    sdoh_2250: 'Log-transformed SEV scalar: Mat Abort',
    sdoh_526: 'Log-transformed SEV scalar: Mat Hem',
    sdoh_733: 'Log-transformed SEV scalar: Mat HIV',
    sdoh_528: 'Log-transformed SEV scalar: Mat HTN',
    sdoh_531: 'Log-transformed SEV scalar: Mat Indir',
    sdoh_532: 'Log-transformed SEV scalar: Mat Late',
    sdoh_527: 'Log-transformed SEV scalar: Mat Sepsis',
    sdoh_1040: 'Log-transformed SEV scalar: Maternal',
    sdoh_622: 'Log-transformed SEV scalar: MDD',
    sdoh_1837: 'Log-transformed SEV scalar: MDR-HIV-TB',
    sdoh_1833: 'Log-transformed SEV scalar: MDR-TB',
    sdoh_503: 'Log-transformed SEV scalar: Measles',
    sdoh_713: 'Log-transformed SEV scalar: Mech',
    sdoh_714: 'Log-transformed SEV scalar: Mech Gun',
    sdoh_494: 'Log-transformed SEV scalar: Meningitis',
    sdoh_573: 'Log-transformed SEV scalar: Mesothel',
    sdoh_705: 'Log-transformed SEV scalar: Mot Cyc',
    sdoh_706: 'Log-transformed SEV scalar: Mot Veh',
    sdoh_1878: 'Log-transformed SEV scalar: MS',
    sdoh_1864: 'Log-transformed SEV scalar: Myeloma',
    sdoh_561: 'Log-transformed SEV scalar: Nasoph C',
    sdoh_1860: 'Log-transformed SEV scalar: NCD',
    sdoh_2188: 'Log-transformed SEV scalar: Neonatal',
    sdoh_1846: 'Log-transformed SEV scalar: NN Enceph',
    sdoh_1848: 'Log-transformed SEV scalar: NN Hemol',
    sdoh_1847: 'Log-transformed SEV scalar: NN Sepsis',
    sdoh_720: 'Log-transformed SEV scalar: Non Ven',
    sdoh_2180: 'Log-transformed SEV scalar: Obst Labor',
    sdoh_658: 'Log-transformed SEV scalar: Osteoarth',
    sdoh_2351: 'Log-Transformed SEV scalar: Osteoarth Hip',
    sdoh_2353: 'Log-Transformed SEV scalar: Osteoarth Knee',
    sdoh_589: 'Log-transformed SEV scalar: Oth Cardio',
    sdoh_2345: 'Log-Transformed SEV scalar: Oth Cirr',
    sdoh_1872: 'Log-transformed SEV scalar: Oth CMP',
    sdoh_724: 'Log-transformed SEV scalar: Oth F Body',
    sdoh_485: 'Log-transformed SEV scalar: Oth HIV',
    sdoh_1869: 'Log-transformed SEV scalar: Oth Leukemia',
    sdoh_553: 'Log-transformed SEV scalar: Oth Liver C',
    sdoh_2349: 'Log-Transformed SEV scalar: Oth Lymphoma',
    sdoh_533: 'Log-transformed SEV scalar: Oth Mat',
    sdoh_716: 'Log-transformed SEV scalar: Oth Mech',
    sdoh_1849: 'Log-transformed SEV scalar: Oth NN',
    sdoh_562: 'Log-transformed SEV scalar: Oth Phar C',
    sdoh_707: 'Log-transformed SEV scalar: Oth Road',
    sdoh_708: 'Log-transformed SEV scalar: Oth Trans',
    sdoh_725: 'Log-transformed SEV scalar: Oth Unint',
    sdoh_730: 'Log-transformed SEV scalar: Oth Viol',
    sdoh_493: 'Log-transformed SEV scalar: Otitis',
    sdoh_567: 'Log-transformed SEV scalar: Ovary C',
    sdoh_587: 'Log-transformed SEV scalar: PAD',
    sdoh_564: 'Log-transformed SEV scalar: Pancreas C',
    sdoh_610: 'Log-transformed SEV scalar: Pancreatit',
    sdoh_703: 'Log-transformed SEV scalar: Pedest',
    sdoh_712: 'Log-transformed SEV scalar: Poison',
    sdoh_558: 'Log-transformed SEV scalar: Prostate C',
    sdoh_1874: 'Log-transformed SEV scalar: PUD',
    sdoh_579: 'Log-transformed SEV scalar: RHD',
    sdoh_1892: 'Log-transformed SEV scalar: Rheu Arth',
    sdoh_702: 'Log-transformed SEV scalar: Road Inj',
    sdoh_1896: 'Log-transformed SEV scalar: Self Fire',
    sdoh_726: 'Log-transformed SEV scalar: Self Harm',
    sdoh_1897: 'Log-transformed SEV scalar: Self Other',
    sdoh_1898: 'Log-transformed SEV scalar: Sex Viol',
    sdoh_701: 'Log-transformed SEV scalar: SIDS',
    sdoh_549: 'Log-transformed SEV scalar: Stomach C',
    sdoh_581: 'Log-transformed SEV scalar: Stroke',
    sdoh_2193: 'Log-transformed SEV scalar: Sub Hem',
    sdoh_483: 'Log-transformed SEV scalar: TB',
    sdoh_572: 'Log-transformed SEV scalar: Thyroid C',
    sdoh_2199: 'Log-transformed SEV scalar: Upper Digest',
    sdoh_492: 'Log-transformed SEV scalar: URI',
    sdoh_557: 'Log-transformed SEV scalar: Uterus C',
    sdoh_2195: 'Log-transformed SEV scalar: Valvular',
    sdoh_719: 'Log-transformed SEV scalar: Venom',
    sdoh_728: 'Log-transformed SEV scalar: Viol Gun',
    sdoh_729: 'Log-transformed SEV scalar: Viol Knife',
    sdoh_727: 'Log-transformed SEV scalar: Violence',
    sdoh_1838: 'Log-transformed SEV scalar: XDR-HIV-TB',
    sdoh_1834: 'Log-transformed SEV scalar: XDR-TB',
    sdoh_1166: 'Low bone mineral density',
    sdoh_2004: 'Low-density lipoprotein (mmol/L) [US R/E]',
    sdoh_1086: 'Major depressive disorder',
    sdoh_1072: 'Malaria incidence adjusted for antimalarial coverage and drug effectiveness',
    sdoh_1130: 'Malaria incidence_MAP',
    sdoh_183: 'Malaria Lysenko PFPR 1 (Holoendemic)',
    sdoh_188: 'Malaria PFPR (rate)',
    sdoh_1169: 'Malnutrition Shock log-transformed mortality rate',
    sdoh_1170: 'Malnutrition Shock mortality rate',
    sdoh_1098: 'Maternal alcohol consumption during pregnancy (proportion)',
    sdoh_208: 'Maternal care and immunization',
    sdoh_463: 'Maternal Education (years per capita)',
    sdoh_2302: 'Max Trachoma Population at risk',
    sdoh_2309: 'MCV1 lagged five year coverage (proportion)',
    sdoh_2310: 'MCV2 lagged five year coverage (proportion)',
    sdoh_2402: 'MDs per capita',
    sdoh_68: 'Mean BMI',
    sdoh_2005: 'Mean BMI (kg/m^2) [US R/E]',
    sdoh_1140: 'Mean hemoglobin concentration (age-standardized)',
    sdoh_1992: 'Mean hemoglobin, age sex specific',
    sdoh_2321: 'Mean number of venomous snake species',
    sdoh_1171: 'Mean war mortality rate in the previous ten years',
    sdoh_75: 'Measles Vaccine Coverage (proportion)',
    sdoh_1108: 'Measles Vaccine Coverage 2 doses (proportion)',
    sdoh_2404: 'Median household income',
    sdoh_2405: 'Median property value',
    sdoh_2294: 'MenAfriVac campaign ever/never',
    sdoh_848: 'meningitis belt (proportion)',
    sdoh_920: 'milk unadjusted(g)',
    sdoh_2033: 'MMR due to abortion and miscarriage ',
    sdoh_2036: 'MMR due to ectopic pregnancy',
    sdoh_2032: 'MMR due to maternal hypertensive disorders ',
    sdoh_2035: 'MMR due to obstructed labor',
    sdoh_2034: 'MMR due to sepsis and other maternal infections',
    sdoh_2031: 'MMR due toe maternal hemorrhage',
    sdoh_79: 'Mortality Rate Due to Death Shocks in Last 10 Years (per 1 person)',
    sdoh_159: 'Mortality Rate Due to War Shocks (per 1 person)',
    sdoh_1218: 'Muslim Religion (proportion of population)',
    sdoh_1245: 'MASLD/MASH prevalence',
    sdoh_209: 'Neonatal Mortality Rate Modeled 2 (per 1000)',
    sdoh_1155: 'No access to handwashing facility',
    sdoh_1994: 'Nurses and Midwives per capita',
    sdoh_926: 'nuts seeds unadjusted(g)',
    sdoh_1973: 'Occupation Professionals',
    sdoh_2332: 'Opioid substitution therapy (OST) treatment coverage',
    sdoh_1255: 'Opioids per million population per day',
    sdoh_1972: 'Opioids per million population per day (10 year lag)',
    sdoh_1971: 'Opioids per million population per day (5 year lag)',
    sdoh_1102: 'ORS (oral rehydration)',
    sdoh_2013: 'Outdoor Air Pollution (PM 2.5) [US R/E]',
    sdoh_106: 'Outdoor Air Pollution (PM2.5)',
    sdoh_210: 'PCV3 Coverage (proportion)',
    sdoh_2314: 'PCV3 lagged five year coverage (proportion)',
    sdoh_1243: 'Pelvic inflammatory disease age-standardized prevalence',
    sdoh_1244: 'Pelvic inflammatory disease all-age prevalence',
    sdoh_1995: 'Pharmacists per capita',
    sdoh_1993: 'Physicians per capita',
    sdoh_100: 'Pigs (per capita)',
    sdoh_1987: 'Pigs raised in extensive agricultural systems per capita',
    sdoh_1989: 'Pigs raised in intensive/industrial agricultural systems per capita',
    sdoh_1988: 'Pigs raised in semi-extensive agricultural systems per capita',
    sdoh_1200: 'Polio 3-dose coverage (proportion)',
    sdoh_2311: 'Polio3 lagged five year coverage (proportion)',
    sdoh_110: 'Population 15 to 30 (proportion)',
    sdoh_2300: 'Population 15 to 30 males (proportion)',
    sdoh_2407: 'Population density',
    sdoh_115: 'Population Density (150-300 ppl/sqkm, proportion)',
    sdoh_116: 'Population Density (300-500 ppl/sqkm, proportion)',
    sdoh_117: 'Population Density (500-1000 ppl/sqkm, proportion)',
    sdoh_118: 'Population Density (over 1000 ppl/sqkm, proportion)',
    sdoh_119: 'Population Density (under 150 ppl/sqkm, proportion)',
    sdoh_120: 'Population Over 65 (proportion)',
    sdoh_247: 'Population weighted probability of dengue transmission',
    sdoh_71: 'Population-weighted mean temperature',
    sdoh_1123: 'Poultry energy unadjusted (g)',
    sdoh_211: 'Presence of leishmaniasis (binary)',
    sdoh_453: 'Prevalence of obesity',
    sdoh_455: 'Prevalence of obesity (age-standardized)',
    sdoh_454: 'Prevalence of overweight and obesity',
    sdoh_2269: 'Proportion 1-4 pop aged 1 year',
    sdoh_2396: 'Proportion foreign-born',
    sdoh_2397: 'Proportion foreign-born age 25+',
    sdoh_2532: 'Proportion Hispanic age 25+',
    sdoh_2408: 'Proportion in college',
    sdoh_2384: 'Proportion in correctional facility',
    sdoh_2516: 'Proportion in poverty',
    sdoh_2410: 'Proportion in poverty age 25+',
    sdoh_2413: 'Proportion land in federal reservations',
    sdoh_2412: 'Proportion land in reservations',
    sdoh_2414: 'Proportion land in state reservations',
    sdoh_2528: 'Proportion non-Hispanic AIAN age 25+',
    sdoh_2529: 'Proportion non-Hispanic API age 25+',
    sdoh_2530: 'Proportion non-Hispanic Black age 25+',
    sdoh_2531: 'Proportion non-Hispanic White age 25+',
    sdoh_1076: 'Proportion of cirrhosis due to alcohol ',
    sdoh_1077: 'Proportion of cirrhosis due to hepatitis B',
    sdoh_1078: 'Proportion of cirrhosis due to hepatitis C',
    sdoh_1217: 'Proportion of cirrhosis due to MASH',
    sdoh_1079: 'Proportion of cirrhosis due to other causes',
    sdoh_46: 'Proportion of households using iodized salt (adjusted)',
    sdoh_1080: 'Proportion of liver cancer due to alcohol (Age Standardized)',
    sdoh_1081: 'Proportion of liver cancer due to hepatitis B (Age Standardized)',
    sdoh_1082: 'Proportion of liver cancer due to hepatitis C (Age Standardized)',
    sdoh_1216: 'Proportion of liver cancer due to MASH (Age Standardized)',
    sdoh_1083: 'Proportion of liver cancer due to other causes (Age Standardized)',
    sdoh_2514: 'Proportion of owner-occupied homes',
    sdoh_1087: 'Proportion of population involved in agricultural activities',
    sdoh_2318: 'Proportion of population vulnerable to venomous snakebites',
    sdoh_250: 'Proportion of the population living in the classic monsoon region',
    sdoh_251:
        'Proportion of the population living in the classic monsoon region (low-income countries)',
    sdoh_441: 'Proportion of the population living in the Indian Ocean monsoon belt',
    sdoh_2264: 'Proportion of the population with 0 years of education',
    sdoh_2266: 'Proportion of the population with 0 years of education, age-standardized',
    sdoh_2265: 'Proportion of the population with 0 years of education, maternal',
    sdoh_2017: 'Proportion of the population with at least 12 years of education',
    sdoh_2022: 'Proportion of the population with at least 12 years of education, age-standardized',
    sdoh_2027: 'Proportion of the population with at least 12 years of education, maternal',
    sdoh_2018: 'Proportion of the population with at least 15 years of education',
    sdoh_2023: 'Proportion of the population with at least 15 years of education, age-standardized',
    sdoh_2028: 'Proportion of the population with at least 15 years of education, maternal',
    sdoh_2016: 'Proportion of the population with at least 6 years of education',
    sdoh_2021: 'Proportion of the population with at least 6 years of education, age-standardized',
    sdoh_2026: 'Proportion of the population with at least 6 years of education, maternal',
    sdoh_2276: 'Proportion of the population working in mining with 20-year lag',
    sdoh_1068:
        'Proportion of total population covered by menafrivac initiative (meningitis meningococcal type A vaccine)',
    sdoh_2268: 'Proportion PNN pop aged 1-5 mo',
    sdoh_2422: 'Proportion rural',
    sdoh_2423: 'Proportion unemployed age 16+',
    sdoh_2424: 'Proportion unemployed age 25+',
    sdoh_2392: 'Proportion with BA+',
    sdoh_2425: 'Proportion with health insurance age 25+',
    sdoh_2394: 'Proportion with HS+',
    sdoh_929: 'pufa adjusted(percent)',
    sdoh_935: 'Pulses legumes unadjusted(g)',
    sdoh_128: 'Rainfall (Quintiles 2-5)',
    sdoh_129: 'Rainfall (Quintiles 3-5)',
    sdoh_130: 'Rainfall (Quintiles 4-5)',
    sdoh_127: 'Rainfall Population-Weighted (mm/yr)',
    sdoh_131: 'Rainfall Quintile 1 (proportion)',
    sdoh_132: 'Rainfall Quintile 2 (proportion)',
    sdoh_133: 'Rainfall Quintile 3 (proportion)',
    sdoh_134: 'Rainfall Quintile 4 (proportion)',
    sdoh_135: 'Rainfall Quintile 5 (proportion)',
    sdoh_2312: 'RCV1 lagged five year coverage (proportion)',
    sdoh_941: 'red meats unadjusted(g)',
    sdoh_137: 'Religion (binary, >50% Muslim)',
    sdoh_1156: 'Residential radon',
    sdoh_2315: 'RotaC lagged five year coverage (proportion)',
    sdoh_1075: 'Rotavirus coverage (proportion)',
    sdoh_1147: 'Rubella Vaccine Coverage (Proportion)',
    sdoh_141: 'Sahel Region of Africa (binary)',
    sdoh_142: 'Sanitation (proportion with access)',
    sdoh_1110: 'Schisto cumulative treatments',
    sdoh_2304: 'Schistosomiasis Prevalence Results',
    sdoh_2293: 'Seat belt frequency (%)',
    sdoh_1183: 'Secondhand smoke',
    sdoh_192: 'Significant leishmaniasis endemicity (binary)',
    sdoh_143: 'Skilled Birth Attendance (proportion)',
    sdoh_145: 'Smoking Prevalence',
    sdoh_282: 'Smoking Prevalence (Age-standardized, both sexes)',
    sdoh_256: 'Smoking Prevalence (Age-standardized, females)',
    sdoh_257: 'Smoking Prevalence (Age-standardized, males)',
    sdoh_146: 'Smoking Prevalence (Reproductive Age Standardized)',
    sdoh_2012: 'Smoking prevalence [US R/E]',
    sdoh_1154: 'Smooth outphase of leaded gasoline',
    sdoh_881: 'Socio-demographic Index',
    sdoh_2341: 'Solar Radiation (downwards)',
    sdoh_2291: 'Speed limit law rural (quartile)',
    sdoh_2290: 'Speed limit law urban (quartile)',
    sdoh_2267: 'Stillbirth to live birth ratio',
    sdoh_962: 'sugar unadjusted(g)',
    sdoh_218: 'Syphilis prevalence (proportion)',
    sdoh_70: 'Systolic Blood Pressure (mmHg)',
    sdoh_2003: 'Systolic blood pressure (mmHg) [US R/E]',
    sdoh_1222: 'TB strain prevalence-weighted transmission RR',
    sdoh_148: 'Tetanus Toxoid Coverage Smooth (proportion)',
    sdoh_2323: 'TFR U20 [US R/E]',
    sdoh_2296: 'Time since any MenAfriVac campaign',
    sdoh_2295: 'Time since last mass MenAfriVac campaign',
    sdoh_14: 'Tobacco (cigarettes per capita)',
    sdoh_2391: 'Tobacco stores per capita, smoothed',
    sdoh_149: 'Total Fertility Rate',
    sdoh_2335: 'Total government spending',
    sdoh_1977: 'Total Physical Activity (MET-min/week), Age-specific',
    sdoh_2009: 'Total physical activity (MET-min/week), age-specific [US R/E]',
    sdoh_1978: 'Total Physical Activity (MET-min/week), Age-standardized',
    sdoh_2010: 'Total physical activity (MET-min/week), age-standardized [US R/E]',
    sdoh_1148: 'Tuberculosis infection risk-weighted prevalence (age-standardized)',
    sdoh_1165: 'Tuberculosis prevalence (age-standardized)',
    sdoh_214: 'Under 5 HIV death rate',
    sdoh_1252: 'Underweight women of reproductive age',
    sdoh_1253: 'Underweight women, age specific',
    sdoh_1097: 'Universal health coverage',
    sdoh_854: 'Urbanicity',
    sdoh_2339: 'Vaccine adjusted HbSAg serporevalence age standardized',
    sdoh_968: 'vegetables unadjusted(g)',
    sdoh_2015: 'Vegetables, unadjusted (g) [US R/E]',
    sdoh_155: 'Vehicles - 2 wheels (per capita)',
    sdoh_157: 'Vehicles - 2 wheels fraction (proportion)',
    sdoh_154: 'Vehicles - 2+4 wheels (per capita)',
    sdoh_156: 'Vehicles - 4 wheels (per capita)',
    sdoh_442: 'Vitamin A Deficiency Prevalence (age-standardized)',
    sdoh_1063: 'vitamin a rae unadjusted (ug)',
    sdoh_1064: 'vitamin a retinol unadjusted (ug)',
    sdoh_2317: 'Vitamin A supplementation (age-specific)',
    sdoh_1062: 'vitamin a unadjusted (iu)',
    sdoh_2305: 'WHO STH MDA Coverage',
    sdoh_195: 'Year',
    sdoh_229: 'Year * GBD analytical region 100',
    sdoh_230: 'Year * GBD analytical region 104',
    sdoh_231: 'Year * GBD analytical region 120',
    sdoh_232: 'Year * GBD analytical region 124',
    sdoh_233: 'Year * GBD analytical region 134',
    sdoh_234: 'Year * GBD analytical region 138',
    sdoh_235: 'Year * GBD analytical region 159',
    sdoh_236: 'Year * GBD analytical region 167',
    sdoh_237: 'Year * GBD analytical region 174',
    sdoh_238: 'Year * GBD analytical region 192',
    sdoh_239: 'Year * GBD analytical region 199',
    sdoh_221: 'Year * GBD analytical region 21',
    sdoh_222: 'Year * GBD analytical region 32',
    sdoh_223: 'Year * GBD analytical region 42',
    sdoh_219: 'Year * GBD analytical region 5',
    sdoh_224: 'Year * GBD analytical region 56',
    sdoh_225: 'Year * GBD analytical region 65',
    sdoh_226: 'Year * GBD analytical region 70',
    sdoh_227: 'Year * GBD analytical region 73',
    sdoh_220: 'Year * GBD analytical region 9',
    sdoh_228: 'Year * GBD analytical region 96',
    sdoh_243: 'Year * GBD analytical superregion 103',
    sdoh_244: 'Year * GBD analytical superregion 137',
    sdoh_245: 'Year * GBD analytical superregion 158',
    sdoh_246: 'Year * GBD analytical superregion 166',
    sdoh_241: 'Year * GBD analytical superregion 31',
    sdoh_240: 'Year * GBD analytical superregion 4',
    sdoh_242: 'Year * GBD analytical superregion 64',
    sdoh_1159: 'Zinc deficiency',
    sdoh_1193: 'Zinc treatment for diarrhea',
};
